import SectionTitle from '@/scopes/destinations/components/SectionTitle'
import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import styles from './InformationSection.module.css'

interface InformationSectionProps { html: string, title: string }

export default function InformationSection({ html, title }: InformationSectionProps) {
  return (
    <section className={styles.wrapper}>
      <SectionTitle className={styles.title}>{title}</SectionTitle>
      <RichText innerHTML={html} />
    </section>
  )
}
